
import { mapState } from 'vuex'
import createBankTransferWithdrawalForm from '~/mixins/common/finance/create-bank-transfer-withdrawal-form'
import withdrawalMinMaxAmountRule from '~/mixins/common/finance/withdrawal-min-max-amount-rule'
export default {
    name: 'Theme3MobileWithdrawalsSteppersFirstStep',
    mixins: [withdrawalMinMaxAmountRule, createBankTransferWithdrawalForm],
    data() {
        return {
            formValid: false,
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.themes.withdraw.loading,
            player: (state) => state.player.player,
        }),
    },
    methods: {
        async doWithdraw() {
            this.$refs?.refWithdraw?.validate()
            if (!this.formValid) return
            this.form.player_bank_account_id = this.selectedBankId
            const result = await this.$store.dispatch(
                'themes/withdraw/createWithdraw',
                this.form
            )
            if (result) {
                this.$emit('doWithdraw', result)
            }
        },
    },
}
